import { NotificationManager } from 'react-notifications';
import jwtDecode from 'jwt-decode';
import { AUTH_COOKIE_NAME } from 'src/constants';
import { AppDispatch } from 'src/store';
import { removeJWTCookie, setAuthToken, setJWTCookie } from 'src/utils/auth';
import Cookies from 'universal-cookie';
import { createAction } from '@reduxjs/toolkit';

import { fetchToken } from './requestHandlers';
import { IAuth, ILoginForm, IParsedToken } from './types';

const cookies = new Cookies();

export const setUserToken = createAction<IAuth, 'auth/set'>('auth/set');

export function loginUser(data: ILoginForm) {
  return async (dispatch: AppDispatch): Promise<void> => {
    try {
      const { accessToken } = await fetchToken(data);
      if (accessToken) {
        const { exp, sub, roles }: IParsedToken = jwtDecode(accessToken);
        setJWTCookie(accessToken, exp);
        dispatch(setUserToken({ token: accessToken, roles, sub }));
      }
    } catch {
      NotificationManager.error("Can't login");
    }
  };
}

export function checkCookie() {
  return async (dispatch: AppDispatch): Promise<void> => {
    const token = cookies.get(AUTH_COOKIE_NAME);
    if (token) {
      const { roles, sub }: IParsedToken = jwtDecode(token);
      dispatch(setUserToken({ token, roles, sub }));
      setAuthToken(token);
    }
  };
}

export function logoutUser() {
  return async (dispatch: AppDispatch): Promise<void> => {
    removeJWTCookie();
    dispatch(setUserToken({ token: '', roles: '', sub: '' }));
  };
}
